import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "FullWidthImageTextCta",
    component: () =>
        __SERVER__ ? require("./full-width-image-text-cta-view") : import("./full-width-image-text-cta-view")
});

export default definition;
